export default __webpack_public_path__ + "static/media/netflix-clone.749778ad.jpg";